// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scbsmb-responsive-container-1 {
  height: 68vh;
  width: 100%;
  min-width: 1000px;
  position: relative;
}



.scbsmb-responsive-container-2 {
  height: 68vh;
  width: 100%;
  min-width: 1000px;
  position: relative;
}
#outer-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:-moz-fit-content;
  width:fit-content;
  /* overflow: auto !important; */
  margin: auto;
  position: relative;
}
#outer-container>div{
  width: 80%;
  margin: auto;
  position: relative;
  right: 3rem;


}
#outer-container>:first-child{
  /* display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
text-align: center; */
}
#outer-container>:first-child>div{
display: flex;
align-items: center;
justify-content: center;
}
#outer-container>:last-child>div{
}
#outer-container>:last-child{
  margin: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;

}
#outer-container>:last-child>:first-child,#outer-container>:last-child>:last-child{
}
#outer-container>:last-child>div{
   width: 61px !important;
  display: flex;
  align-items: center;
  justify-content: center; 
  padding-top: 5px;
  font-weight: 600;
  font-size: 0.8rem;
}
#outer-container>:first-child>div>:first-child{
  font-weight: 600;
  font-size: 0.8rem;

}
#outer-container>:first-child>div>div{
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 1000px) {
  .scbsmb-responsive-container-1 {
  }
}

@media screen and (max-width: 800px) {
  .scbsmb-responsive-container-2 {
 /* min-width: 1500px; */
  }
}

`, "",{"version":3,"sources":["webpack://./src/modules/SCBSMB/scbsmb.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAiB;EAAjB,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;;;AAGb;AACA;EACE;;;;qBAImB;AACrB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB;AACA;AACA;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;AAEzB;AACA;AACA;AACA;GACG,sBAAsB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;EACA;AACF;;AAEA;EACE;CACD,uBAAuB;EACtB;AACF","sourcesContent":[".scbsmb-responsive-container-1 {\r\n  height: 68vh;\r\n  width: 100%;\r\n  min-width: 1000px;\r\n  position: relative;\r\n}\r\n\r\n\r\n\r\n.scbsmb-responsive-container-2 {\r\n  height: 68vh;\r\n  width: 100%;\r\n  min-width: 1000px;\r\n  position: relative;\r\n}\r\n#outer-container{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  width:fit-content;\r\n  /* overflow: auto !important; */\r\n  margin: auto;\r\n  position: relative;\r\n}\r\n#outer-container>div{\r\n  width: 80%;\r\n  margin: auto;\r\n  position: relative;\r\n  right: 3rem;\r\n\r\n\r\n}\r\n#outer-container>:first-child{\r\n  /* display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\ntext-align: center; */\r\n}\r\n#outer-container>:first-child>div{\r\ndisplay: flex;\r\nalign-items: center;\r\njustify-content: center;\r\n}\r\n#outer-container>:last-child>div{\r\n}\r\n#outer-container>:last-child{\r\n  margin: auto !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n}\r\n#outer-container>:last-child>:first-child,#outer-container>:last-child>:last-child{\r\n}\r\n#outer-container>:last-child>div{\r\n   width: 61px !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center; \r\n  padding-top: 5px;\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n}\r\n#outer-container>:first-child>div>:first-child{\r\n  font-weight: 600;\r\n  font-size: 0.8rem;\r\n\r\n}\r\n#outer-container>:first-child>div>div{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n@media screen and (max-width: 1000px) {\r\n  .scbsmb-responsive-container-1 {\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  .scbsmb-responsive-container-2 {\r\n /* min-width: 1500px; */\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
